import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import MenuComponent from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Menu from "@material-ui/icons/Menu";

import { logEvent } from "../../utils/Analytics";
import { ActionButtonProps, MENUS, MenuProps } from "./Menu";
import { Quantifiction } from "./Quantifiction";
import { LOGIN_LINK, SIGNUP_LINK } from "../../utils/Constants";
import { forwardUrlToApp } from "../../utils/Utils";

export interface Props {
  onSideBarOpen: () => void;
}

export const TopBar = (props: Props) => {
  const { onSideBarOpen } = props;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={1}
    >
      <Box flexGrow={0} flexShrink={0}>
        <Quantifiction />
      </Box>
      <Box
        display={{ xs: "none", md: "flex" }}
        flexWrap="wrap"
        alignItems="center"
      >
        {MENUS.map((m) => (
          <DesktopMenu {...m} />
        ))}

        <ActionButton
          label="Login"
          variant="outlined"
          href={LOGIN_LINK}
          eventName="login"
        />
        <ActionButton
          label="Signup"
          variant="contained"
          href={SIGNUP_LINK}
          eventName="sign_up"
          eventParams={{ place: "top-bar" }}
          marginLeft={true}
        />
      </Box>
      <Box
        display={{ xs: "flex", md: "none" }}
        flexWrap="wrap"
        alignItems="center"
      >
        <Button onClick={() => onSideBarOpen()} variant="outlined">
          <Menu />
        </Button>
      </Box>
    </Box>
  );
};

const ActionButton = (props: ActionButtonProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const { href, label, eventName, eventParams, variant, marginLeft } = props;
  const url = forwardUrlToApp(href);

  return (
    <Box ml={marginLeft ? 1 : 0} flexShrink={0} flexGrow={0}>
      <Button
        variant={variant ?? "outlined"}
        color="primary"
        size={isSmall ? "small" : "medium"}
        href={url}
        fullWidth={isSmall ? false : true}
        onClick={() => logEvent(eventName, eventParams)}
      >
        {label}
      </Button>
    </Box>
  );
};

const DesktopMenu = (props: MenuProps) => {
  const { label, to, items, eventName } = props;
  const [anchor, setAnchor] = React.useState<HTMLElement | undefined>(
    undefined
  );

  if (!!to) {
    return (
      <Box mr={4} flexShrink={0} flexGrow={0}>
        <Link
          component={RouterLink}
          color="textPrimary"
          to={to}
          onClick={() => {
            if (eventName) {
              logEvent(eventName);
            }
          }}
        >
          <Typography variant="subtitle1">{label}</Typography>
        </Link>
      </Box>
    );
  }

  const open = Boolean(anchor);

  return (
    <Box mr={4} flexShrink={0} flexGrow={0}>
      <Link
        color="textPrimary"
        component="button"
        underline="none"
        onClick={(e: any) => {
          setAnchor(e.currentTarget);
        }}
      >
        <Typography variant="subtitle1">
          {open ? <b>{label}</b> : label}
          <Box display="inline" ml={0.25}>
            {open ? (
              <ExpandLess
                fontSize="inherit"
                style={{ position: "relative", top: 2 }}
              />
            ) : (
              <ExpandMore
                fontSize="inherit"
                style={{ position: "relative", top: 2 }}
              />
            )}
          </Box>
        </Typography>
      </Link>
      {!!items && (
        <MenuComponent
          keepMounted={true}
          anchorEl={anchor}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          getContentAnchorEl={undefined}
          open={open}
          onClose={() => setAnchor(undefined)}
        >
          {items.map((i) =>
            !!i ? (
              <MenuItem
                onClick={() => {
                  logEvent(i.eventName);
                  setAnchor(undefined);
                }}
                component={RouterLink}
                to={i.to}
              >
                {i.label}
              </MenuItem>
            ) : undefined
          )}
        </MenuComponent>
      )}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/TopBar.tsx